import { Skeleton } from '@chakra-ui/react';
import { Colors, Text } from '@mercator-gcp/grout';
import { FlexColumn } from 'components/layout/FlexColumn/FlexColumn';
import { FlexRow } from 'components/layout/FlexRow';
import { formatInteger } from 'utils/format';

const projectCountStyles = {
  justifyContent: 'flex-start',
  gap: 'padding_24',
};

type Props = {
  activeProjects?: number;
  completedProjects?: number;
  isLoading?: boolean;
};

const CompanyProjectsHeader = ({
  activeProjects,
  completedProjects,
  isLoading,
}: Props) => {
  return (
    <FlexRow sx={projectCountStyles}>
      <FlexColumn>
        <Text.SmallLabel color={Colors.TextQuiet}>Active Projects</Text.SmallLabel>
        <Skeleton isLoaded={!isLoading}>
          <Text.Lead>{formatInteger(activeProjects)}</Text.Lead>
        </Skeleton>
      </FlexColumn>
      <FlexColumn>
        <Text.SmallLabel color={Colors.TextQuiet}>Completed Projects</Text.SmallLabel>
        <Skeleton isLoaded={!isLoading}>
          <Text.Lead>{formatInteger(completedProjects)}</Text.Lead>
        </Skeleton>
      </FlexColumn>
    </FlexRow>
  );
};

export default CompanyProjectsHeader;
